import { supabase } from '../context/AuthContext';

const getAccessToken = async () => {
  const { data } = await supabase.auth.getSession();
  return data?.session?.access_token || null;
};

const callArchiveFunction = async (functionName, body) => {
  const accessToken = await getAccessToken();
  if (!accessToken) {
    throw new Error('Sign in again to continue.');
  }

  const response = await fetch(
    `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/${functionName}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(body),
    }
  );

  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.error || `Failed to ${functionName.replace('-', ' ')}`);
    error.code = result.code;
    error.status = response.status;
    error.details = result;
    throw error;
  }

  return result;
};

export const archiveOrder = (submissionId, archiveReason) =>
  callArchiveFunction('archive-order', {
    submission_id: submissionId,
    archive_reason: archiveReason,
  });

export const restoreOrder = (submissionId) =>
  callArchiveFunction('restore-order', {
    submission_id: submissionId,
  });

/** Statuses that may be archived (Paid never). */
export const canArchiveOrderStatus = (status) => {
  const normalized = String(status || 'Processing').trim().toLowerCase();
  return normalized === 'processing' || normalized === 'payment pending';
};
